import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { httpConfigInterceptor } from './httpconfig.interceptor';
import { spinnerInterceptor } from './spinner.interceptor';

export const httpInterceptorProviders = [
  provideHttpClient(
    withInterceptors([
      httpConfigInterceptor,
      spinnerInterceptor
    ])
  )
];
